module.exports = __webpack_public_path__ + "static/media/homewise-for-advisors.5144a66d.png";